import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Input, Modal } from '../ui';

/**
 * Name + description dialog used when saving a builder or SQL report.
 * The parent performs the API call and passes any server error back in.
 */
const SaveReportModal = ({ isOpen, onClose, initialValues, onSubmit, serverError, submitting, title = 'Save report' }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: { name: '', description: '' } });

  useEffect(() => {
    if (isOpen) reset({ name: initialValues?.name || '', description: initialValues?.description || '' });
  }, [isOpen, initialValues, reset]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="md">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <Input
          label="Name"
          autoFocus
          placeholder="e.g. Sales by cashier and month"
          error={errors.name?.message}
          {...register('name', {
            required: 'Name is required',
            maxLength: { value: 150, message: 'Keep the name under 150 characters' },
            validate: (v) => v.trim().length > 0 || 'Name is required',
          })}
        />
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea
            rows={3}
            placeholder="What this report shows and who it is for (optional)"
            className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            {...register('description', { maxLength: { value: 1000, message: 'Keep the description under 1000 characters' } })}
          />
          {errors.description && <p className="text-sm text-red-600">{errors.description.message}</p>}
        </div>
        {serverError && <p className="text-sm text-red-600">{serverError}</p>}
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="submit" disabled={submitting}>
            {submitting ? 'Saving…' : 'Save'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default SaveReportModal;
